import { useEffect } from 'react';

type JsonLdProps = {
  data: object;
};

/**
 * @description
 * 구조화 데이터(JSON-LD)를 <head>에 주입하는 공통 컴포넌트입니다.
 * 검색엔진·AI 크롤러가 페이지의 의미(매물·FAQ·이동경로 등)를 이해하도록 돕습니다.
 *
 * react-helmet 은 React 18 동시성 렌더링 레이스로 태그가 유실될 수 있어(SeoMetaTags.tsx 참고)
 * useEffect 로 <script> 를 직접 관리합니다. JSON-LD 는 원본 그대로 출력해야 유효하며,
 * &lt; 만 < 로 이스케이프해 데이터에</script> 가 섞여도 스크립트가 조기 종료되지 않게 합니다.
 */
function JsonLd({ data }: JsonLdProps) {
  const json = JSON.stringify(data).replace(/</g, '\\u003c');

  useEffect(() => {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.text = json;
    el.dataset.seoJsonld = 'true';
    document.head.appendChild(el);

    return () => {
      el.remove();
    };
  }, [json]);

  return null;
}

export default JsonLd;
